(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6908],{

/***/ 70015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ box; },
/* harmony export */   "E8": function() { return /* binding */ saveSearchContentTop; },
/* harmony export */   "GV": function() { return /* binding */ saveSearchContent; },
/* harmony export */   "_R": function() { return /* binding */ geoInfo; }
/* harmony export */ });
/* harmony import */ var src_components_Modal_Types_SaveSearch_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_components_Modal_Types_SaveSearch_styles_css_ts_vanilla_css_source_Ll8xeDU4YWFxMCB7CiAgb3ZlcmZsb3c6IGhpZGRlbjsKICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpczsKICB3aGl0ZS1zcGFjZTogbm93cmFwOwogIHBhZGRpbmctYm90dG9tOiAyNHB4Owp9Ci5fMXg1OGFhcTEgewogIGJhY2tncm91bmQ6ICNGRkZGRkY7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDBweCAwcHggNnB4IHJnYmEoNTEsIDY4LCA4NCwgMC4yNCk7CiAgbWFyZ2luLWJvdHRvbTogMTZweDsKICBtYXJnaW4tbGVmdDogLTEycHg7CiAgbWFyZ2luLXJpZ2h0OiAtMTJweDsKICBwYWRkaW5nOiAxMnB4Owp9Ci5fMXg1OGFhcTIgewogIGRpc3BsYXk6IGZsZXg7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBmbGV4LWdyb3c6IDE7CiAgbWF4LXdpZHRoOiAzNDRweDsKICB3aWR0aDogMTAwJTsKICBtYXJnaW46IDAgYXV0bzsKfQouXzF4NThhYXEzIHsKICBmbGV4LWdyb3c6IDE7Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83795);
/* harmony import */ var src_components_Modal_Types_SaveSearch_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_components_Modal_Types_SaveSearch_styles_css_ts_vanilla_css_source_Ll8xeDU4YWFxMCB7CiAgb3ZlcmZsb3c6IGhpZGRlbjsKICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpczsKICB3aGl0ZS1zcGFjZTogbm93cmFwOwogIHBhZGRpbmctYm90dG9tOiAyNHB4Owp9Ci5fMXg1OGFhcTEgewogIGJhY2tncm91bmQ6ICNGRkZGRkY7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDBweCAwcHggNnB4IHJnYmEoNTEsIDY4LCA4NCwgMC4yNCk7CiAgbWFyZ2luLWJvdHRvbTogMTZweDsKICBtYXJnaW4tbGVmdDogLTEycHg7CiAgbWFyZ2luLXJpZ2h0OiAtMTJweDsKICBwYWRkaW5nOiAxMnB4Owp9Ci5fMXg1OGFhcTIgewogIGRpc3BsYXk6IGZsZXg7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBmbGV4LWdyb3c6IDE7CiAgbWF4LXdpZHRoOiAzNDRweDsKICB3aWR0aDogMTAwJTsKICBtYXJnaW46IDAgYXV0bzsKfQouXzF4NThhYXEzIHsKICBmbGV4LWdyb3c6IDE7Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(src_components_Modal_Types_SaveSearch_styles_css_ts_vanilla_css_node_modules_vanilla_extract_webpack_plugin_virtualFileLoader_dist_vanilla_extract_webpack_plugin_virtualFileLoader_cjs_js_fileName_src_components_Modal_Types_SaveSearch_styles_css_ts_vanilla_css_source_Ll8xeDU4YWFxMCB7CiAgb3ZlcmZsb3c6IGhpZGRlbjsKICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpczsKICB3aGl0ZS1zcGFjZTogbm93cmFwOwogIHBhZGRpbmctYm90dG9tOiAyNHB4Owp9Ci5fMXg1OGFhcTEgewogIGJhY2tncm91bmQ6ICNGRkZGRkY7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDBweCAwcHggNnB4IHJnYmEoNTEsIDY4LCA4NCwgMC4yNCk7CiAgbWFyZ2luLWJvdHRvbTogMTZweDsKICBtYXJnaW4tbGVmdDogLTEycHg7CiAgbWFyZ2luLXJpZ2h0OiAtMTJweDsKICBwYWRkaW5nOiAxMnB4Owp9Ci5fMXg1OGFhcTIgewogIGRpc3BsYXk6IGZsZXg7CiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsKICBmbGV4LWdyb3c6IDE7CiAgbWF4LXdpZHRoOiAzNDRweDsKICB3aWR0aDogMTAwJTsKICBtYXJnaW46IDAgYXV0bzsKfQouXzF4NThhYXEzIHsKICBmbGV4LWdyb3c6IDE7Cn0_node_modules_vanilla_extract_webpack_plugin_extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs_js__WEBPACK_IMPORTED_MODULE_0__);

var box = '_1x58aaq1';
var geoInfo = '_1x58aaq0';
var saveSearchContent = '_1x58aaq2';
var saveSearchContentTop = '_1x58aaq3';

/***/ }),

/***/ 6763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ContentDefault; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(88718);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(3292);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./src/components/Icon/BaseSvg.tsx
var BaseSvg = __webpack_require__(57586);
// EXTERNAL MODULE: ./src/design-lib/theme.ts
var theme = __webpack_require__(56161);
;// CONCATENATED MODULE: ./src/components/Icon/BellNotification/index.tsx



var BellNotification = function(param) {
    var className = param.className, ellipseColor = param.ellipseColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseSvg/* default */.Z, {
        className: className,
        height: "28",
        viewBox: "0 0 28 28",
        width: "28",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                clipRule: "evenodd",
                d: "M0.000522296 22H3V14.5C3 10.5109 5.59531 7.12792 9.18953 5.94751C9.6153 4.81041 10.713 4 12 4C13.2865 4 14.3839 4.80985 14.8102 5.94758C18.404 7.12698 21 10.5103 21 14.5V22H23.9995L24 25L16.2435 25.0014C15.989 25.7205 15.557 26.3557 15 26.8542C14.2039 27.5667 13.1525 28 12 28C10.8475 28 9.79613 27.5667 9 26.8542C8.44304 26.3557 8.01097 25.7205 7.75654 25.0014L0 25L0.000522296 22ZM6.00734 14.2005L6 14.5V22H18V14.5C18 11.2867 15.474 8.66338 12.2995 8.50734L12 8.5C8.78671 8.5 6.16338 11.026 6.00734 14.2005Z",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "22",
                cy: "6.99984",
                fill: theme/* theme.colors */.r.colors[ellipseColor],
                rx: "6",
                ry: "5.83333"
            })
        ]
    });
};
/* harmony default export */ var Icon_BellNotification = (BellNotification);

// EXTERNAL MODULE: ./src/components/Translated.tsx
var Translated = __webpack_require__(36510);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/context/BottomSheetContext.tsx + 2 modules
var BottomSheetContext = __webpack_require__(88628);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/design-lib/components/Icons/Bell/index.tsx
var Bell = __webpack_require__(12336);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/i18n-routes.ts
var i18n_routes = __webpack_require__(31693);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/navigation.ts + 1 modules
var navigation = __webpack_require__(59165);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/styles.css.ts
var SaveSearch_styles_css = __webpack_require__(70015);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentWrapper.tsx
var ContentWrapper = __webpack_require__(71634);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
;// CONCATENATED MODULE: ./src/components/Icon/Magnify/index.tsx




var Magnify = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6.5 0C10.09 0 13 2.91 13 6.5c0 1.434-.464 2.759-1.25 3.834l3.907 3.909-1.414 1.414-3.91-3.907C9.26 12.536 7.934 13 6.5 13 2.91 13 0 10.09 0 6.5S2.91 0 6.5 0zm0 2C4.015 2 2 4.015 2 6.5S4.015 11 6.5 11 11 8.985 11 6.5 8.985 2 6.5 2z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    }));
};
/* harmony default export */ var Icon_Magnify = (Magnify);

// EXTERNAL MODULE: ./src/utils/filters-mapper.ts
var filters_mapper = __webpack_require__(31750);
// EXTERNAL MODULE: ./src/utils/format-currency.ts
var format_currency = __webpack_require__(58577);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/FilterInfo.tsx



var FilterInfo = function(param) {
    var className = param.className, label = param.label, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                color: "greyscale400",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                className: styles_css/* ellipsis */.LH,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    children: value
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/styles.css.ts
var Content_styles_css = __webpack_require__(4776);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/ListingContact/SaveSearchDetail.tsx + 1 modules
var SaveSearchDetail = __webpack_require__(76418);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/ListingContact/FiltersBoxListingContact.tsx











var FiltersBoxListingContact = function(param) {
    var listing = param.listing;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: SaveSearch_styles_css/* box */.BZ,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    styles_css/* flexCenter */._7,
                    styles_css/* paddingBottom.m */.Et.m,
                    styles_css/* gap.m */.SG.m
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_Magnify, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        children: t("save-search:your_research")
                    })
                ]
            }),
            listing.detail.sellingPrices && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInfo, {
                label: t("save-search:price"),
                value: filters_mapper/* default.formatRange */.Z.formatRange((0,format_currency/* formatPrice */.T)({
                    cents: (0,SaveSearchDetail/* getPriceMinCents */.YD)(listing.detail.sellingPrices && listing.detail.sellingPrices.cents)
                }, lang), (0,format_currency/* formatPrice */.T)({
                    cents: (0,SaveSearchDetail/* getPriceMaxCents */.A8)(listing.detail.sellingPrices && listing.detail.sellingPrices.cents)
                }, lang), t)
            }),
            !!listing.characteristics.rooms && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: Content_styles_css/* lightP */.Df,
                        children: t("save-search:features_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "".concat(listing.characteristics.rooms, " ").concat(t(listing.characteristics.rooms > 1 ? "filter:rooms" : "filter:room"))
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 21 modules
var Icon = __webpack_require__(81016);
// EXTERNAL MODULE: ./src/context/CityPageContext.tsx
var CityPageContext = __webpack_require__(72023);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/SearchResults/EmptyFiltersBox.tsx










var EmptyFiltersBox = function() {
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    var t = (0,useTranslation/* default */.Z)().t;
    var openFilterModal = (0,CityPageContext/* useCityPage */.zh)().openFilterModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: SaveSearch_styles_css/* box */.BZ,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: [
                styles_css/* flexCenter */._7,
                styles_css/* gap.m */.SG.m
            ].join(" "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Info */.Z.Info, {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        alignSelf: "flex-start",
                        flexShrink: 0
                    }),
                    height: 20,
                    width: 20
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Description */.dk, {
                            strong: true,
                            className: styles_css/* marginBottom.xs */.yl.xs,
                            children: t("save-search:Modal_NoFilterBanner_Title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                            children: t("save-search:Modal_NoFilterBanner_Description")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                    className: (0,sprinkles_css/* sprinkles */.K)({
                        flexShrink: 0,
                        padding: "s"
                    }),
                    label: t("save-search:Modal_NoFilterBanner_CTA"),
                    styleVariant: "tertiary",
                    onClick: function() {
                        (0,eventsHandlers/* handleNewListingsAlertClick */.Tu)("OpenFilterModal");
                        closeModal();
                        openFilterModal();
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Icon/CasavoLogoSmall/index.tsx
var CasavoLogoSmall = __webpack_require__(5260);
// EXTERNAL MODULE: ./src/types/graphql-generated-types.ts
var graphql_generated_types = __webpack_require__(98733);
// EXTERNAL MODULE: ./src/utils/filters-configuration.ts
var filters_configuration = __webpack_require__(86307);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/SearchResults/FeaturesList.tsx







var getTranslateString = function(type, name) {
    var ref, ref1;
    var otherFilterConfiguration = filters_configuration/* default.others */.Z.others();
    var values = ((ref = otherFilterConfiguration.find(function(c) {
        return c.name === type;
    })) === null || ref === void 0 ? void 0 : ref.values) || [];
    return ((ref1 = values.find(function(v) {
        return v.key === name;
    })) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
};
var FeaturesList = function(param) {
    var filters = param.filters;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,useTranslation/* default */.Z)().t;
    var listRangeNumber = [
        {
            component: FilterRange,
            label: "mq",
            value: filters.byArea
        },
        {
            component: FilterRange,
            label: "".concat(t(((ref = filters.byRooms) === null || ref === void 0 ? void 0 : ref.to) > 1 || ((ref1 = filters.byRooms) === null || ref1 === void 0 ? void 0 : ref1.from) > 1 ? "filter:rooms" : "filter:room")),
            value: filters.byRooms
        },
        {
            component: FilterNumber,
            label: "".concat(t(((ref2 = filters.byBedrooms) === null || ref2 === void 0 ? void 0 : ref2.from) > 1 ? "filter:bedrooms" : "filter:bedroom")),
            value: (ref3 = filters.byBedrooms) === null || ref3 === void 0 ? void 0 : ref3.from
        },
        {
            component: FilterNumber,
            label: "".concat(t(((ref4 = filters.byBathrooms) === null || ref4 === void 0 ? void 0 : ref4.from) > 1 ? "filter:bathrooms" : "filter:bathroom")),
            value: (ref5 = filters.byBathrooms) === null || ref5 === void 0 ? void 0 : ref5.from
        }, 
    ];
    var listArrayServices = [
        {
            component: FilterArrayString,
            filterName: "byFloor"
        },
        {
            component: FilterArrayString,
            filterName: "byStateOfMaintenance"
        },
        {
            component: FilterArrayString,
            filterName: "byStateAtDeed"
        },
        {
            component: FilterServices,
            filterName: "onlyWithElevator"
        },
        {
            component: FilterServices,
            filterName: "onlyWithParking"
        },
        {
            component: FilterServices,
            filterName: "onlyWithBox"
        },
        {
            component: FilterServices,
            filterName: "onlyWithBasement"
        },
        {
            component: FilterServices,
            filterName: "onlyWithGarden"
        },
        {
            component: FilterServices,
            filterName: "onlyWithBalcony"
        },
        {
            component: FilterServices,
            filterName: "onlyWithTerrace"
        },
        {
            component: FilterServices,
            filterName: "onlyWithPool"
        },
        {
            component: FilterServices,
            filterName: "onlyWithCoolingSystem"
        },
        {
            component: FilterServices,
            filterName: "onlyWithConciergeService"
        },
        {
            component: FilterArrayString,
            filterName: "byHeatingSystem"
        }, 
    ];
    var hasFeatures = function() {
        return listRangeNumber.some(function(filter) {
            return !!filter.value;
        }) || listArrayServices.some(function(filter) {
            return !!filters[filter.filterName];
        }) || (filters === null || filters === void 0 ? void 0 : filters.byConstructionYear);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: hasFeatures() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: Content_styles_css/* lightP */.Df,
                    children: t("save-search:features_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: Content_styles_css/* featureList */.zs,
                    "data-testid": "features-list",
                    children: [
                        listRangeNumber.map(function(filter, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(filter.component, {
                                label: filter.label,
                                value: filter.value
                            }, i);
                        }),
                        listArrayServices.map(function(filter, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(filter.component, {
                                filterName: filter.filterName,
                                filters: filters
                            }, i);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRange, {
                            value: filters.byConstructionYear
                        })
                    ]
                })
            ]
        })
    });
};
var FilterDivider = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: Content_styles_css/* pointShapeDivider */.wx,
        color: index_es/* colors.greyscale600 */.O9.greyscale600
    });
};
var FilterRange = function(param) {
    var label = param.label, value = param.value;
    var t = (0,useTranslation/* default */.Z)().t;
    return value ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            filters_mapper/* default.formatRange */.Z.formatRange(value.from, value.to, t),
            " ",
            label,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDivider, {})
        ]
    }) : null;
};
var FilterNumber = function(param) {
    var label = param.label, value = param.value;
    return value ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            value,
            " ",
            label,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDivider, {})
        ]
    }) : null;
};
var FilterArrayString = function(param) {
    var filterName = param.filterName, filters = param.filters;
    var ref;
    var t = (0,useTranslation/* default */.Z)().t;
    var translatedValue = (ref = filters[filterName]) === null || ref === void 0 ? void 0 : ref.map(function(v) {
        return t("filter:".concat(getTranslateString(filterName, v)));
    });
    return translatedValue ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            translatedValue.join(", "),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDivider, {})
        ]
    }) : null;
};
var FilterServices = function(param) {
    var filterName = param.filterName, filters = param.filters;
    var servicesValues = filters_configuration/* default.getServicesValues */.Z.getServicesValues().reduce(function(acc, cur) {
        acc[cur.key] = cur;
        return acc;
    }, {});
    var t = (0,useTranslation/* default */.Z)().t;
    return filters[filterName] ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            t("filter:".concat(servicesValues[filterName].value)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDivider, {})
        ]
    }) : null;
};
/* harmony default export */ var SearchResults_FeaturesList = (FeaturesList);

;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/SearchResults/FiltersBoxSearchResults.tsx












var FiltersBoxSearchResults = function(param) {
    var filters = param.filters;
    var ref = (0,useTranslation/* default */.Z)(), lang = ref.lang, t = ref.t;
    var formatFilterByPrice = function(byPrice) {
        var toMoney = function(price) {
            return {
                __typename: "Money",
                cents: price * 100,
                currency: graphql_generated_types/* Currency.Eur */.F.Eur
            };
        };
        return filters_mapper/* default.formatRange */.Z.formatRange((0,format_currency/* formatPrice */.T)(toMoney(byPrice.from), lang), (0,format_currency/* formatPrice */.T)(toMoney(byPrice.to), lang), t);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: SaveSearch_styles_css/* box */.BZ,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    styles_css/* flexCenter */._7,
                    styles_css/* paddingBottom.m */.Et.m,
                    styles_css/* gap.m */.SG.m
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_Magnify, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        children: t("save-search:your_research")
                    })
                ]
            }),
            filters.byResidentialType && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInfo, {
                className: styles_css/* paddingBottom.s-m */.Et["s-m"],
                label: t("filter:typology"),
                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterArrayString, {
                    filterName: "byResidentialType",
                    filters: filters
                })
            }),
            filters.byPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInfo, {
                label: t("save-search:price"),
                value: formatFilterByPrice(filters.byPrice)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_FeaturesList, {
                filters: filters
            }),
            filters.onlyCasavo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    styles_css/* flexCenter */._7,
                    styles_css/* gap.s */.SG.s,
                    styles_css/* marginTop.s */.E9.s
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CasavoLogoSmall/* default */.Z, {
                        height: "18px",
                        width: "16px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Description */.dk, {
                        children: [
                            " ",
                            t("save-search:only_casavo")
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentLogin/index.tsx
var ContentLogin = __webpack_require__(28214);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/GeoInfo.tsx
var GeoInfo = __webpack_require__(27442);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentDefault.tsx

























var ContentDefault = function(param) {
    var actualZoneFilterAreas = param.actualZoneFilterAreas, cities = param.cities, filters = param.filters, geoSlugs = param.geoSlugs, handleSubmitUserFavoriteSearch = param.handleSubmitUserFavoriteSearch, listing = param.listing, origin = param.origin, setIsLoadingFavouriteSearch = param.setIsLoadingFavouriteSearch, setShowContentLogin = param.setShowContentLogin, userEmail = param.userEmail;
    var ref, ref1;
    var ref2 = (0,useTranslation/* default */.Z)(), lang = ref2.lang, t = ref2.t;
    var device = (0,Device/* useDevice */.Fy)();
    var user = (0,AuthProvider/* useAuthentication */.JL)().user;
    var ref3 = (0,BottomSheetContext/* useBottomSheet */.a)(), closeBottomSheet = ref3.closeBottomSheet, openBottomSheet = ref3.openBottomSheet;
    var _ref = filters !== null && filters !== void 0 ? filters : {}, byZone = _ref.byZone, filtersWithoutZone = (0,_object_without_properties/* default */.Z)(_ref, [
        "byZone"
    ]);
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* ContentWrapper */.v, {
        className: (0,sprinkles_css/* sprinkles */.K)({
            padding: "l"
        }),
        origin: origin,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: {
                        desktop: "xl",
                        mobile: "l"
                    }
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_BellNotification, {
                        className: styles_css/* marginBottom.s */.yl.s,
                        ellipseColor: "orange600"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading2 */.XJ, {
                        alignment: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Translated/* Translated */.I, {
                            i18Key: "save-search:Modal_Title"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: SaveSearch_styles_css/* saveSearchContent */.GV,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: SaveSearch_styles_css/* saveSearchContentTop */.E8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                children: t("save-search:Modal_Zone_intro")
                            }),
                            origin === "SEARCH_RESULTS" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GeoInfo/* GeoInfo */.m, {
                                        activeZones: actualZoneFilterAreas.filter(function(item) {
                                            return item.kind === "zone";
                                        }),
                                        area: (ref4 = (ref = cities.router.city) === null || ref === void 0 ? void 0 : ref.translatedCityName) !== null && ref4 !== void 0 ? ref4 : "".concat(cities.router.area.translatedCityName, " ").concat(t("common:province"))
                                    }),
                                    Object.keys(filtersWithoutZone).length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBoxSearchResults, {
                                        filters: filters
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyFiltersBox, {})
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                                        strong: true,
                                        className: SaveSearch_styles_css/* geoInfo */._R,
                                        children: "".concat((ref5 = (ref1 = cities.router.city) === null || ref1 === void 0 ? void 0 : ref1.translatedCityName) !== null && ref5 !== void 0 ? ref5 : "".concat(cities.router.area.translatedCityName, " ").concat(t("common:province"))).concat(listing.detail.zone ? ", ".concat(listing.detail.zone.label) : "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersBoxListingContact, {
                                        listing: listing
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Caption */.YS, {
                        alignment: "center",
                        className: styles_css/* paddingBottom.m */.Et.m,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "aria-label": "coffee",
                                className: styles_css/* marginRight.xs */.wz.xs,
                                role: "img",
                                children: "☕️"
                            }),
                            " ",
                            t("save-search:Modal_Form_NotificationsMessage")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        center: true,
                        className: styles_css/* marginBottom.m */.yl.m,
                        "data-testid": "save-search-button",
                        Icon: function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bell/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
                        },
                        label: t("save-search:Modal_CTA"),
                        minWidth: 160,
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                (0,eventsHandlers/* handleNewListingsAlertClick */.Tu)("ModalButtonCTA", origin === "SEARCH_RESULTS" ? "ListingsFeed" : "ListingDetail");
                                if (user) {
                                    handleSubmitUserFavoriteSearch();
                                } else if (device === "mobile") {
                                    openBottomSheet(origin === "SEARCH_RESULTS" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLogin/* ContentLogin */.n, {
                                        actualZoneFilterAreas: actualZoneFilterAreas,
                                        filters: filters,
                                        geoSlugs: geoSlugs,
                                        origin: origin,
                                        setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch,
                                        onLoggedIn: function() {
                                            return closeBottomSheet();
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLogin/* ContentLogin */.n, {
                                        listing: listing,
                                        origin: origin,
                                        setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch,
                                        userEmail: userEmail,
                                        onLoggedIn: function() {
                                            return closeBottomSheet();
                                        }
                                    }), {
                                        minHeight: 610
                                    });
                                } else {
                                    setShowContentLogin(true);
                                }
                                return [
                                    2
                                ];
                            });
                        })
                    }),
                    user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Small */.x4, {
                        alignment: "center",
                        color: "greyscale500",
                        children: [
                            t("save-search:Modal_AuthUser_Text"),
                            " ",
                            user.email,
                            " - ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (0,sprinkles_css/* sprinkles */.K)({
                                    fontWeight: 600,
                                    textDecoration: "underline"
                                }),
                                href: (0,navigation/* buildRelativeLocalizedLink */.JS)(i18n_routes/* profilePath */.J$, lang),
                                onClick: function() {
                                    return (0,eventsHandlers/* handleNewListingsAlertClick */.Tu)("Profile");
                                },
                                children: t("save-search:Modal_AuthUser_Link")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 46983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ ContentLoader; },
  "N": function() { return /* binding */ FORCED_LOADING_TIME; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(42493);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: src/design-lib/style-theme/sprinkles.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/design-lib/style-theme/sprinkles.css.ts.vanilla.css","source":"#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"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(1851);
// EXTERNAL MODULE: src/shared-styles/vanilla-keyframes.css.tsx.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/shared-styles/vanilla-keyframes.css.tsx.vanilla.css","source":"QGtleWZyYW1lcyB4aTg3aWwwIHsKICAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCk7CiAgfQogIDUwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoNXB4KTsKICB9CiAgMTAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoMCk7CiAgfQp9CkBrZXlmcmFtZXMgeGk4N2lsMSB7CiAgMCUgewogICAgYmFja2dyb3VuZC1wb3NpdGlvbjogLTIwMHB4IDA7CiAgfQogIDEwMCUgewogICAgYmFja2dyb3VuZC1wb3NpdGlvbjogY2FsYygyMDBweCArIDEwMCUpIDA7CiAgfQp9CkBrZXlmcmFtZXMgeGk4N2lsMiB7CiAgMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoM2RlZyk7CiAgfQogIDUwJSB7CiAgICB0cmFuc2Zvcm06IHJvdGF0ZSgtM2RlZyk7CiAgfQogIDEwMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoM2RlZyk7CiAgfQp9CkBrZXlmcmFtZXMgeGk4N2lsMyB7CiAgMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7CiAgfQogIDEwMCUgewogICAgdHJhbnNmb3JtOiByb3RhdGUoMzYwZGVnKTsKICB9Cn0KQGtleWZyYW1lcyB4aTg3aWw0IHsKICAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSkgcm90YXRlKDQ1ZGVnKTsKICB9CiAgMTAwJSB7CiAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoNTAwJSkgcm90YXRlKDQ1ZGVnKTsKICB9Cn0KQGtleWZyYW1lcyB4aTg3aWw1IHsKICBmcm9tIHsKICAgIHdpZHRoOiAwOwogIH0KICB0byB7CiAgICB3aWR0aDogMTAwJTsKICB9Cn0KQGtleWZyYW1lcyB4aTg3aWw2IHsKICA1MCUgewogICAgYm9yZGVyLWNvbG9yOiAjMUQxRDFCOwogIH0KICBmcm9tIHsKICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7CiAgfQogIHRvIHsKICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7CiAgfQp9"}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(60786);
// EXTERNAL MODULE: src/components/Modal/Types/SaveSearch/Content/Common/ContentLoader/style.css.ts.vanilla.css!=!./node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"src/components/Modal/Types/SaveSearch/Content/Common/ContentLoader/style.css.ts.vanilla.css","source":"Lmc5ZXRmZTEgewogIGJhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7Cn0KLmc5ZXRmZTMgewogIGFuaW1hdGlvbjogeGk4N2lsMiAxLjJzIGVhc2UgaW5maW5pdGU7Cn0="}!./node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var extracted_dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(10538);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentLoader/style.css.ts



var contentLoaderWrapper = 'g9etfe1 tfghjg6 tfghjg1u tfghjga3 tfghjgac';
var loaderImage = 'g9etfe3 tfghjgb3 tfghjgko';
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentLoader/index.tsx






var FORCED_LOADING_TIME = 2000;
var ContentLoader = function() {
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    var t = (0,useTranslation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: contentLoaderWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: loaderImage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 124,
                        role: "img",
                        src: "".concat(imageBasePath, "/images/concepts/time.svg"),
                        width: 124
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                    children: t("save-search:LoaderModal_Description")
                })
            ]
        })
    });
};


/***/ }),

/***/ 28214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ContentLogin; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _components_auth_UserAuthentication__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21682);
/* harmony import */ var _components_ConceptImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24454);
/* harmony import */ var _components_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28820);
/* harmony import */ var _context_Device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77808);
/* harmony import */ var _utils_isStorageSupported__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17668);
/* harmony import */ var _ContentWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71634);








var ContentLogin = function(param) {
    var onLoggedIn = param.onLoggedIn, origin = param.origin;
    var device = (0,_context_Device__WEBPACK_IMPORTED_MODULE_5__/* .useDevice */ .Fy)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), returnUrl = ref[0], setReturnUrl = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setReturnUrl(window.location.href);
        (0,_utils_isStorageSupported__WEBPACK_IMPORTED_MODULE_7__/* .isStorageSupported */ .p)(function() {
            return sessionStorage;
        }) && sessionStorage.setItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN", JSON.stringify({
            origin: origin,
            pageUrl: window.location.href
        }));
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConditionalWrapper__WEBPACK_IMPORTED_MODULE_4__/* .ConditionalWrapper */ .M, {
        condition: device === "desktop",
        wrapper: function(children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ContentWrapper__WEBPACK_IMPORTED_MODULE_6__/* .ContentWrapper */ .v, {
                bgColor: "lightBlue",
                origin: origin,
                children: children
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_auth_UserAuthentication__WEBPACK_IMPORTED_MODULE_2__/* .UserAuthentication */ .z, {
            conceptImage: device === "mobile" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConceptImage__WEBPACK_IMPORTED_MODULE_3__/* .ConceptImage */ .t, {
                height: 96,
                name: "mail-pidgeon",
                width: 96
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ConceptImage__WEBPACK_IMPORTED_MODULE_3__/* .ConceptImage */ .t, {
                height: 120,
                name: "mail",
                width: 120
            }),
            mainTitle: "Login_SaveSearch_BottomSheet_Title",
            returnUrl: returnUrl,
            showCasavoLogo: false,
            touchPoint: "FromSaveSearch",
            onLoggedIn: onLoggedIn
        })
    });
};


/***/ }),

/***/ 71634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ContentWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29559);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79713);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Icon_Close__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87411);
/* harmony import */ var _context_ModalContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32228);
/* harmony import */ var _design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20579);
/* harmony import */ var _shared_styles_styles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29070);
/* harmony import */ var _utils_css_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22106);
/* harmony import */ var _utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88905);










var ContentWrapper = function(param) {
    var backToInitialScroll = param.backToInitialScroll, bgColor = param.bgColor, children = param.children, className = param.className, origin = param.origin;
    var closeModal = (0,_context_ModalContext__WEBPACK_IMPORTED_MODULE_4__/* .useModal */ .dd)().closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_shared_styles_styles_css__WEBPACK_IMPORTED_MODULE_6__/* .flexColumnSpaceBetween */ .hh, _shared_styles_styles_css__WEBPACK_IMPORTED_MODULE_6__/* .backgroundColor */ .Cz[bgColor], className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                ariaLabel: "Close",
                className: (0,_design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_5__/* .sprinkles */ .K)({
                    position: "absolute",
                    right: "m",
                    top: "m",
                    zIndex: (0,_utils_css_utils__WEBPACK_IMPORTED_MODULE_8__/* .zIndex */ .W)("modalContent")
                }),
                "data-testid": "save-search-close-modal",
                Icon: function(props) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Icon_Close__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props));
                },
                shapeVariant: "round",
                styleVariant: "tertiary",
                onClick: function() {
                    closeModal({
                        shouldBackToInitialScroll: backToInitialScroll
                    });
                    (0,_utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_7__/* .handleNewListingsAlertClick */ .Tu)("CloseModal", origin === "SEARCH_RESULTS" ? "ListingsFeed" : "ListingDetail");
                }
            }),
            children
        ]
    });
};


/***/ }),

/***/ 27442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ GeoInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79713);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70015);




var GeoInfo = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .BodyM */ .iO, {
        strong: true,
        className: _styles_css__WEBPACK_IMPORTED_MODULE_3__/* .geoInfo */ ._R,
        children: [
            props.area,
            props.activeZones.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    ", \xa0",
                    props.activeZones.map(function(zone, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                            children: [
                                zone.label,
                                index !== props.activeZones.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: ", \xa0"
                                })
                            ]
                        }, zone.slug);
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 76418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ ListingContact_SaveSearchDetail; },
  "A8": function() { return /* binding */ getPriceMaxCents; },
  "YD": function() { return /* binding */ getPriceMinCents; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(88718);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(50879);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/context/AuthProvider/index.ts + 2 modules
var AuthProvider = __webpack_require__(95374);
// EXTERNAL MODULE: ./src/context/BottomSheetContext.tsx + 2 modules
var BottomSheetContext = __webpack_require__(88628);
// EXTERNAL MODULE: ./src/context/Device.tsx
var Device = __webpack_require__(77808);
// EXTERNAL MODULE: ./src/context/ModalContext.tsx
var ModalContext = __webpack_require__(32228);
// EXTERNAL MODULE: ./src/design-lib/components/Toast/ToastError/index.tsx
var ToastError = __webpack_require__(7929);
// EXTERNAL MODULE: ./src/lib/api-gluglu-auth.ts
var api_gluglu_auth = __webpack_require__(636);
// EXTERNAL MODULE: ./src/utils/isStorageSupported.ts
var isStorageSupported = __webpack_require__(17668);
// EXTERNAL MODULE: ./src/utils/tracking/eventsHandlers.ts + 1 modules
var eventsHandlers = __webpack_require__(88905);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Form/createPayload.ts + 1 modules
var createPayload = __webpack_require__(60625);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentDefault.tsx + 7 modules
var ContentDefault = __webpack_require__(6763);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentLoader/index.tsx + 1 modules
var ContentLoader = __webpack_require__(46983);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentLogin/index.tsx
var ContentLogin = __webpack_require__(28214);
// EXTERNAL MODULE: ./node_modules/@casavo/base-ui/dist/index.es.js
var index_es = __webpack_require__(79713);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 97 modules
var motion = __webpack_require__(38494);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(89847);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/components/framer-motion-variants.tsx
var framer_motion_variants = __webpack_require__(20635);
// EXTERNAL MODULE: ./src/design-lib/style-theme/sprinkles.css.ts
var sprinkles_css = __webpack_require__(20579);
// EXTERNAL MODULE: ./src/shared-styles/styles.css.ts
var styles_css = __webpack_require__(29070);
// EXTERNAL MODULE: ./src/utils/dom-interactions-helpers.ts
var dom_interactions_helpers = __webpack_require__(16360);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/Common/ContentWrapper.tsx
var ContentWrapper = __webpack_require__(71634);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/ListingContact/ContentSuccess.tsx













var ContentSuccess = function(param) {
    var similarPropertiesLength = param.similarPropertiesLength;
    var t = (0,useTranslation/* default */.Z)().t;
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    var device = (0,Device/* useDevice */.Fy)();
    var ref = config_default()(), imageBasePath = ref.publicRuntimeConfig.imageBasePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* ContentWrapper */.v, {
        className: (0,sprinkles_css/* sprinkles */.K)({
            padding: "l"
        }),
        origin: "LISTING_CONTACT",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            animate: "animate",
            className: styles_css/* flexColumnSpaceBetween */.hh,
            initial: "initial",
            variants: framer_motion_variants/* fadeInAnimation */.BX,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,sprinkles_css/* sprinkles */.K)({
                    marginX: {
                        desktop: "5xl",
                        mobile: "m"
                    },
                    marginY: "auto"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "",
                        className: (0,sprinkles_css/* sprinkles */.K)({
                            marginBottom: "2xl",
                            marginX: "auto"
                        }),
                        height: 138,
                        src: "".concat(imageBasePath, "/images/concepts/simple-small.svg"),
                        width: 138
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Heading3 */.aC, {
                        as: "h2",
                        className: styles_css/* paddingBottom.s-m */.Et["s-m"],
                        children: t("save-search:SearchSearch_Modal_Success_Title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BodyM */.iO, {
                        className: styles_css/* paddingBottom.2xl */.Et["2xl"],
                        children: t("save-search:SearchSearch_Modal_Success_Subtitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                        center: true,
                        className: styles_css/* marginBottom.l */.yl.l,
                        label: t("save-search:SearchSearch_Modal_Success_CTA"),
                        sizeVariant: "big",
                        styleVariant: "secondary",
                        onClick: function() {
                            closeModal();
                            (0,eventsHandlers/* handleClick */.qk)("ListingDetailForm", "ToSimilarPropertiesFromSaveSearchSuccess");
                            setTimeout(function() {
                                similarPropertiesLength > 0 ? (0,dom_interactions_helpers/* anchorSmoothScroll */.e)("#similarProperties", device === "mobile" ? 0 : -100) : window.scrollTo({
                                    behavior: "smooth",
                                    top: 0
                                });
                            }, 1000);
                        }
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Content/ListingContact/SaveSearchDetail.tsx

















var getPriceMinCents = function(priceCents) {
    return priceCents && Math.ceil(priceCents * 0.9 / 1000000) * 1000000;
};
var getPriceMaxCents = function(priceCents) {
    return priceCents && Math.ceil(priceCents * 1.1 / 1000000) * 1000000;
};
var SaveSearchDetail = function(param) {
    var cities = param.cities, listing = param.listing, onSaveSuccess = param.onSaveSuccess, similarPropertiesLength = param.similarPropertiesLength, userEmail = param.userEmail;
    var ref = (0,react.useState)(false), isSaveSearchSuccessInternalState = ref[0], setIsSaveSearchSuccessInternalState = ref[1];
    var ref1 = (0,react.useState)(false), isLoadingFavoriteSearch = ref1[0], setIsLoadingFavouriteSearch = ref1[1];
    var ref2 = (0,react.useState)(false), showContentLogin = ref2[0], setShowContentLogin = ref2[1];
    var ref3 = (0,AuthProvider/* useAuthentication */.JL)(), isLoadingUser = ref3.isLoading, user = ref3.user;
    var ref4 = (0,react.useState)(false), error = ref4[0], setError = ref4[1];
    var device = (0,Device/* useDevice */.Fy)();
    var closeModal = (0,ModalContext/* useModal */.dd)().closeModal;
    var closeBottomSheet = (0,BottomSheetContext/* useBottomSheet */.a)().closeBottomSheet;
    var handleSubmitUserFavoriteSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, favoriteSearchPayload, _e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        favoriteSearchPayload = (0,createPayload/* createPayload */.Z)({
                            listing: listing,
                            origin: "LISTING_CONTACT",
                            referenceCitySlug: (ref = cities.router.area) === null || ref === void 0 ? void 0 : ref.slug
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setIsLoadingFavouriteSearch(true);
                        setShowContentLogin(false);
                        closeBottomSheet();
                        return [
                            4,
                            api_gluglu_auth/* default.submitUserFavoriteSearch */.ZP.submitUserFavoriteSearch(favoriteSearchPayload)
                        ];
                    case 2:
                        _state.sent();
                        (0,eventsHandlers/* handleNewListingsAlertClick */.Tu)("ActivateAlert", "ListingDetail");
                        onSaveSuccess();
                        setIsSaveSearchSuccessInternalState(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        _e = _state.sent();
                        (0,eventsHandlers/* handleSystem */.o0)("NewListingsAlert", "ActivateAlertError");
                        setError(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setTimeout(function() {
                            setIsLoadingFavouriteSearch(false);
                        }, ContentLoader/* FORCED_LOADING_TIME */.N);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitUserFavoriteSearch() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        isSaveSearchSuccessInternalState && onSaveSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSaveSearchSuccessInternalState
    ]);
    (0,react.useEffect)(function() {
        function run() {
            return _run.apply(this, arguments);
        }
        function _run() {
            _run = (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    handleSubmitUserFavoriteSearch();
                    return [
                        2
                    ];
                });
            });
            return _run.apply(this, arguments);
        }
        if (!isLoadingUser && user && (0,isStorageSupported/* isStorageSupported */.p)(function() {
            return sessionStorage;
        }) && sessionStorage.getItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN")) {
            run().finally(function() {
                sessionStorage.removeItem("CASAVO@LISTINGS-SAVE-SEARCH-AFTER-LOGIN");
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user,
        isLoadingUser
    ]);
    if (device === "mobile") {
        return !isSaveSearchSuccessInternalState && !isLoadingFavoriteSearch ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDefault/* ContentDefault */.I, {
                    cities: cities,
                    handleSubmitUserFavoriteSearch: handleSubmitUserFavoriteSearch,
                    listing: listing,
                    origin: "LISTING_CONTACT",
                    setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch,
                    userEmail: userEmail
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastError/* ToastError */.b, {
                    error: error,
                    setError: setError
                })
            ]
        }) : isLoadingFavoriteSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoader/* ContentLoader */.p, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSuccess, {
            similarPropertiesLength: similarPropertiesLength
        });
    } else {
        return !isSaveSearchSuccessInternalState && !isLoadingFavoriteSearch && !showContentLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentDefault/* ContentDefault */.I, {
                    cities: cities,
                    handleSubmitUserFavoriteSearch: handleSubmitUserFavoriteSearch,
                    listing: listing,
                    origin: "LISTING_CONTACT",
                    setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch,
                    setShowContentLogin: setShowContentLogin,
                    userEmail: userEmail
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToastError/* ToastError */.b, {
                    error: error,
                    setError: setError
                })
            ]
        }) : isLoadingFavoriteSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoader/* ContentLoader */.p, {}) : showContentLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLogin/* ContentLogin */.n, {
            listing: listing,
            origin: "LISTING_CONTACT",
            setIsLoadingFavouriteSearch: setIsLoadingFavouriteSearch,
            userEmail: userEmail,
            onLoggedIn: function() {
                return closeModal();
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSuccess, {
            similarPropertiesLength: similarPropertiesLength
        });
    }
};
/* harmony default export */ var ListingContact_SaveSearchDetail = (SaveSearchDetail);


/***/ }),

/***/ 60625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createPayload; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(29559);
// EXTERNAL MODULE: ./src/components/Modal/Types/SaveSearch/Content/ListingContact/SaveSearchDetail.tsx + 1 modules
var SaveSearchDetail = __webpack_require__(76418);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(62271);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(61978);
;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Form/helper-map-filters.ts



var mapRange = function(range) {
    if (!range) return undefined;
    if (!range.from && !range.to) return undefined;
    return {
        from: range.from || null,
        to: range.to || null
    };
};
var mapAmenities = function(filters) {
    var amenities = {
        balcony: filters === null || filters === void 0 ? void 0 : filters.onlyWithBalcony,
        basement: filters === null || filters === void 0 ? void 0 : filters.onlyWithBasement,
        box: filters === null || filters === void 0 ? void 0 : filters.onlyWithBox,
        conciergeService: filters === null || filters === void 0 ? void 0 : filters.onlyWithConciergeService,
        coolingSystem: filters === null || filters === void 0 ? void 0 : filters.onlyWithCoolingSystem,
        elevator: filters === null || filters === void 0 ? void 0 : filters.onlyWithElevator,
        garden: filters === null || filters === void 0 ? void 0 : filters.onlyWithGarden,
        parking: filters === null || filters === void 0 ? void 0 : filters.onlyWithParking,
        pool: filters === null || filters === void 0 ? void 0 : filters.onlyWithPool,
        terrace: filters === null || filters === void 0 ? void 0 : filters.onlyWithTerrace
    };
    var reducedAmenities = (0,lodash.omitBy)(amenities, lodash.isNil);
    return (0,lodash.isEmpty)(reducedAmenities) ? undefined : reducedAmenities;
};
var mapForFavoriteSearch = function(filters) {
    var searchCriteria = {
        area: mapRange(filters === null || filters === void 0 ? void 0 : filters.byArea),
        bathrooms: mapRange(filters === null || filters === void 0 ? void 0 : filters.byBathrooms),
        bedrooms: mapRange(filters === null || filters === void 0 ? void 0 : filters.byBedrooms),
        constructionYear: mapRange(filters === null || filters === void 0 ? void 0 : filters.byConstructionYear),
        floor: filters === null || filters === void 0 ? void 0 : filters.byFloor,
        heatingSystem: filters === null || filters === void 0 ? void 0 : filters.byHeatingSystem,
        mustHaveAmenities: mapAmenities(filters),
        price: mapRange(filters === null || filters === void 0 ? void 0 : filters.byPrice),
        residentialType: filters === null || filters === void 0 ? void 0 : filters.byResidentialType,
        rooms: mapRange(filters === null || filters === void 0 ? void 0 : filters.byRooms),
        stateAtDeed: filters === null || filters === void 0 ? void 0 : filters.byStateAtDeed,
        stateOfMaintenance: filters === null || filters === void 0 ? void 0 : filters.byStateOfMaintenance
    };
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,lodash.omitBy)(searchCriteria, lodash.isNil)), {
        onlyCasavo: (filters === null || filters === void 0 ? void 0 : filters.onlyCasavo) || false
    });
};

;// CONCATENATED MODULE: ./src/components/Modal/Types/SaveSearch/Form/createPayload.ts



var createPayload = function(param) {
    var actualZoneFilterAreas = param.actualZoneFilterAreas, email = param.email, filters = param.filters, geoSlugs = param.geoSlugs, listing = param.listing, origin = param.origin, referenceCitySlug = param.referenceCitySlug;
    if (origin === "SEARCH_RESULTS") {
        var actualZoneFilterSlugs = (actualZoneFilterAreas === null || actualZoneFilterAreas === void 0 ? void 0 : actualZoneFilterAreas.map(function(param) {
            var slug = param.slug;
            return slug;
        })) || [];
        var favoriteSearchFilters = mapForFavoriteSearch(filters);
        return {
            email: email,
            origin: "SEARCH_RESULTS",
            searchCriteria: (0,_object_spread/* default */.Z)({
                geoSlugs: actualZoneFilterSlugs.length > 0 ? actualZoneFilterSlugs : geoSlugs,
                referenceCitySlug: referenceCitySlug
            }, favoriteSearchFilters)
        };
    }
    return {
        email: email,
        origin: "LISTING_CONTACT",
        searchCriteria: {
            geoSlugs: listing.detail.zone ? [
                listing.detail.zone.slug
            ] : [
                listing.detail.city
            ],
            onlyCasavo: false,
            price: {
                from: listing.detail.sellingPrices && (0,SaveSearchDetail/* getPriceMinCents */.YD)(listing.detail.sellingPrices.cents) / 100,
                to: listing.detail.sellingPrices && (0,SaveSearchDetail/* getPriceMaxCents */.A8)(listing.detail.sellingPrices.cents) / 100
            },
            referenceCitySlug: referenceCitySlug,
            rooms: {
                from: listing.characteristics.rooms,
                to: listing.characteristics.rooms
            }
        }
    };
};


/***/ }),

/***/ 72023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kz": function() { return /* binding */ CityPageContextProvider; },
/* harmony export */   "zh": function() { return /* binding */ useCityPage; }
/* harmony export */ });
/* unused harmony export CityPageContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var _utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88905);





var contextValue = {
    aggregate: {
        isAggregateListOpen: false,
        selectedAggregate: {
            address: "",
            aggregateLength: 0
        },
        setAggregateListOpen: function() {
            return undefined;
        },
        setSelectedAggregate: function() {
            return undefined;
        }
    },
    closeBreadcrumbModal: function() {
        return undefined;
    },
    closeFilterModal: function() {
        return undefined;
    },
    filters: {
        hasJustAppliedFilters: false,
        setHasJustAppliedFilters: function() {
            return undefined;
        }
    },
    isBreadcrumbModalOpen: false,
    isFilterModalOpen: false,
    mapState: {
        isMapFullPage: false,
        scrollPosition: 0,
        setMapFullPage: function() {
            return undefined;
        },
        setScrollPosition: function() {
            return undefined;
        }
    },
    openBreadcrumbModal: function() {
        return undefined;
    },
    openFilterModal: function() {
        return undefined;
    },
    saveSearchButtonState: "default",
    setSaveSearchButtonState: function() {
        return undefined;
    }
};
var CityPageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(contextValue);
var useCityPage = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CityPageContext);
    if (!context) {
        throw new Error("useCityPage must be used within a CityPageContextProvider");
    }
    return context;
};
var CityPageContextProvider = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("default"), buttonState = ref[0], setButtonState = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isFilterModalOpen = ref1[0], setIsFilterModalOpen = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBreadcrumbModalOpen = ref2[0], setIsBreadcrumbModalOpen = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAggregateListOpen = ref3[0], setAggregateListOpen = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        address: "",
        aggregateLength: 0
    }), selectedAggregate = ref4[0], setSelectedAggregate = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMapFullPage = ref5[0], setMapFullPage = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasJustAppliedFilters = ref6[0], setHasJustAppliedFilters = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), scrollPosition = ref7[0], setScrollPosition = ref7[1];
    var openFilterModal = function() {
        return setIsFilterModalOpen(true);
    };
    var closeFilterModal = function() {
        return setIsFilterModalOpen(false);
    };
    var openBreadcrumbModal = function() {
        var trackingLabel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Open";
        setIsBreadcrumbModalOpen(true);
        (0,_utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_2__/* .handleListingsPageBreadcrumbClick */ .BF)(trackingLabel);
    };
    var closeBreadcrumbModal = function() {
        var trackingLabel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Close", eventValue = arguments.length > 1 ? arguments[1] : void 0;
        setIsBreadcrumbModalOpen(false);
        (0,_utils_tracking_eventsHandlers__WEBPACK_IMPORTED_MODULE_2__/* .handleListingsPageBreadcrumbClick */ .BF)(trackingLabel, eventValue);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CityPageContext.Provider, {
        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, contextValue), {
            aggregate: {
                isAggregateListOpen: isAggregateListOpen,
                selectedAggregate: selectedAggregate,
                setAggregateListOpen: setAggregateListOpen,
                setSelectedAggregate: setSelectedAggregate
            },
            closeBreadcrumbModal: closeBreadcrumbModal,
            closeFilterModal: closeFilterModal,
            filters: {
                hasJustAppliedFilters: hasJustAppliedFilters,
                setHasJustAppliedFilters: setHasJustAppliedFilters
            },
            isBreadcrumbModalOpen: isBreadcrumbModalOpen,
            isFilterModalOpen: isFilterModalOpen,
            mapState: {
                isMapFullPage: isMapFullPage,
                scrollPosition: scrollPosition,
                setMapFullPage: setMapFullPage,
                setScrollPosition: setScrollPosition
            },
            openBreadcrumbModal: openBreadcrumbModal,
            openFilterModal: openFilterModal,
            saveSearchButtonState: buttonState,
            setSaveSearchButtonState: setButtonState
        }), props),
        children: props.children
    });
};


/***/ }),

/***/ 29961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ usePageYOffset; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);

var usePageYOffset = function(callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function() {
            callback(window.scrollY);
        };
        window.addEventListener("scroll", handler);
        return function() {
            window.removeEventListener("scroll", handler);
        };
    }, []);
};


/***/ }),

/***/ 31551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTagManager; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3292);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32466);
/* harmony import */ var _utils_tracking_trackingUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4464);




var useTagManager = function(_param) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var pageType = _param.pageType, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "pageType"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (typeof window.dataLayer !== "undefined") {
            (0,_utils_tracking_trackingUtils__WEBPACK_IMPORTED_MODULE_1__/* .dataLayerPush */ .lQ)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                agencyName: undefined,
                city: undefined,
                event: "casavo.pageview",
                listingId: undefined,
                listingPrice: undefined,
                pageType: pageType,
                propertyIsOwnedByCasavo: undefined,
                propertyStreetAddress: undefined
            }, props));
        }
    }, deps);
};


/***/ }),

/***/ 15037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getBreadcrumbList; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89847);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13976);
/* harmony import */ var _utils_get_translated_title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22862);



// FIXME: Add types
var getItemHomePage = function(publicRuntimeConfig, t, language) {
    return {
        item: publicRuntimeConfig.lisaWebsite + _components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_1__/* .linkBuilder.housesForSale.url */ .H.housesForSale.url(language),
        name: t("common:footer-our-properties-label"),
        position: 1
    };
};
var getItemZone = function(publicRuntimeConfig, language, cities, cityValue, zone) {
    return zone ? {
        item: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_1__/* .linkBuilder.listingByCity.url */ .H.listingByCity.url(language, cities, cityValue)).concat(zone.slug.split("/")[2].concat("/")),
        name: zone.label,
        position: 3
    } : null;
};
var getItemCity = function(publicRuntimeConfig, language, cities, translatedCityName, cityValue) {
    return cityValue ? {
        item: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_1__/* .linkBuilder.listingByCity.url */ .H.listingByCity.url(language, cities, cityValue)),
        name: translatedCityName,
        position: 2
    } : null;
};
var getItemDetail = function(publicRuntimeConfig, language, cities, property) {
    var ref;
    return {
        item: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_1__/* .linkBuilder.listingDetail.url */ .H.listingDetail.url(language, property.slug)),
        name: property ? (0,_utils_get_translated_title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((ref = property.detail) === null || ref === void 0 ? void 0 : ref.titles, language) : "",
        position: 4
    };
};
var getBreadcrumbList = function(param) {
    var cities = param.cities, city = param.city, depth = param.depth, language = param.language, property = param.property, t = param.t, zone = param.zone;
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig;
    var itemHomePage = getItemHomePage(publicRuntimeConfig, t, language);
    switch(depth){
        case "listings":
            return [
                itemHomePage,
                getItemCity(publicRuntimeConfig, language, cities, city.translatedCityName, city.slug),
                getItemZone(publicRuntimeConfig, language, cities, city.slug, zone || (property === null || property === void 0 ? void 0 : property.detail.zone)), 
            ].filter(Boolean);
        case "listingDetail":
            var areZoneEnabledForCity = city.city_zones.length > 0;
            return [
                itemHomePage,
                getItemCity(publicRuntimeConfig, language, cities, city.translatedCityName, city.slug),
                getItemZone(publicRuntimeConfig, language, cities, city.slug, areZoneEnabledForCity && (property === null || property === void 0 ? void 0 : property.detail.zone)),
                getItemDetail(publicRuntimeConfig, language, cities, property), 
            ].filter(Boolean);
    }
};


/***/ }),

/***/ 16360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ anchorSmoothScroll; }
/* harmony export */ });
var anchorSmoothScroll = function(idSelector) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var yOffset = offset;
    var target = document.querySelector(idSelector);
    var y = (target === null || target === void 0 ? void 0 : target.getBoundingClientRect().top) + window.pageYOffset + yOffset;
    window.scrollTo({
        behavior: "smooth",
        top: y
    });
};


/***/ }),

/***/ 86307:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var priority = function() {
    return [
        {
            description: "",
            from: {
                maxValue: 10000000,
                minValue: 0,
                placeholder: "€ - -",
                step: 5000
            },
            includeThousandsSeparator: true,
            isRange: true,
            label: "price",
            name: "byPrice",
            prefix: "€ ",
            span: "€",
            suffix: "",
            thousandsSeparatorSymbol: ".",
            to: {
                maxValue: 10000000,
                minValue: 0,
                placeholder: "€ - -",
                step: 5000
            },
            trendy: true,
            type: "money"
        },
        {
            description: "",
            from: {
                maxValue: 10,
                minValue: 0,
                placeholder: "-",
                step: 1
            },
            isRange: true,
            label: "rooms",
            name: "byRooms",
            to: {
                maxValue: 10,
                minValue: 0,
                placeholder: "-",
                step: 1
            },
            trendy: true,
            type: "number"
        },
        {
            description: "",
            from: {
                maxValue: 1000,
                minValue: 0,
                placeholder: "- - m\xb2  ",
                step: 1
            },
            includeThousandsSeparator: false,
            isRange: true,
            label: "surface",
            name: "byArea",
            prefix: "",
            span: "  m\xb2  ",
            suffix: " m\xb2",
            to: {
                maxValue: 1000,
                minValue: 0,
                placeholder: "- -   m\xb2  ",
                step: 1
            },
            trendy: true,
            type: "money"
        }, 
    ];
};
var getServicesValues = function() {
    return [
        {
            icon: "elevator",
            key: "onlyWithElevator",
            value: "elevator"
        },
        {
            icon: "parkingSpaces",
            key: "onlyWithParking",
            value: "parkingSpaces"
        },
        {
            icon: "box",
            key: "onlyWithBox",
            value: "box"
        },
        {
            icon: "basement",
            key: "onlyWithBasement",
            value: "cellar"
        },
        {
            icon: "garden",
            key: "onlyWithGarden",
            value: "garden"
        },
        {
            icon: "balcony",
            key: "onlyWithBalcony",
            value: "balcony"
        },
        {
            icon: "terrace",
            key: "onlyWithTerrace",
            value: "terrace"
        },
        {
            icon: "pool",
            key: "onlyWithPool",
            value: "pool"
        },
        {
            icon: "coolingSystem",
            key: "onlyWithCoolingSystem",
            value: "coolingSystem"
        },
        {
            icon: "conciergeService",
            key: "onlyWithConciergeService",
            value: "conciergeService"
        }, 
    ];
};
var others = function() {
    return [
        {
            description: "Tipologia",
            label: "typology",
            multi: true,
            name: "byResidentialType",
            priority: 2,
            trendy: false,
            type: "button-list",
            values: [
                {
                    key: null,
                    value: "anyone_choice"
                },
                {
                    key: "APARTMENT",
                    value: "apartment"
                },
                {
                    key: "HOUSE",
                    value: "house"
                },
                {
                    key: "TOWNHOUSE",
                    value: "townhouse"
                },
                {
                    key: "VILLA",
                    value: "villa"
                },
                {
                    key: "LOFT",
                    value: "loft"
                },
                {
                    key: "ATTIC",
                    value: "attic"
                },
                {
                    key: "MANSARD",
                    value: "mansard"
                }, 
            ]
        },
        {
            description: "Camere",
            label: "bedrooms",
            name: "byBedrooms",
            priority: 3,
            trendy: false,
            type: "at-least"
        },
        {
            description: "Bagni",
            label: "bathrooms",
            name: "byBathrooms",
            priority: 4,
            trendy: false,
            type: "at-least"
        },
        {
            description: "Piano di ingresso",
            label: "entrance_floor",
            multi: true,
            name: "byFloor",
            priority: 5,
            trendy: false,
            type: "button-list",
            values: [
                {
                    key: null,
                    value: "anyone_choice"
                },
                {
                    key: "BASEMENT",
                    value: "basement"
                },
                {
                    key: "GROUND_FLOOR",
                    value: "ground_floor"
                },
                {
                    key: "MID_FLOOR",
                    value: "mid_floor"
                },
                {
                    key: "LAST_FLOOR",
                    value: "last_floor"
                }, 
            ]
        },
        {
            description: "Condizioni Immobile",
            label: "state_of_manteinance",
            multi: true,
            name: "byStateOfMaintenance",
            priority: 6,
            trendy: false,
            type: "button-list",
            values: [
                {
                    key: null,
                    value: "anyone_choice"
                },
                {
                    key: "HABITABLE",
                    value: "habitable_status"
                },
                {
                    key: "RENOVATED",
                    value: "renovated_status"
                },
                {
                    key: "NEED_RENOVATION",
                    value: "need_renovation_status"
                },
                {
                    key: "NEW",
                    value: "new_status"
                }, 
            ]
        },
        {
            description: "Stato al rogito",
            label: "state_at_deed",
            multi: true,
            name: "byStateAtDeed",
            priority: 7,
            trendy: false,
            type: "button-list",
            values: [
                {
                    key: null,
                    value: "anyone_choice"
                },
                {
                    key: "OCCUPIED",
                    value: "OCCUPIED"
                },
                {
                    key: "FREE",
                    value: "FREE"
                }, 
            ]
        },
        {
            description: "Servizi",
            label: "services",
            multi: true,
            priority: 8,
            trendy: false,
            type: "toggle-list",
            values: getServicesValues()
        },
        {
            description: "Riscaldamento",
            label: "heating_system",
            multi: true,
            name: "byHeatingSystem",
            priority: 10,
            trendy: false,
            type: "button-list",
            values: [
                {
                    key: null,
                    value: "anyone_choice"
                },
                {
                    key: "AUTONOMOUS",
                    value: "AUTONOMOUS"
                },
                {
                    key: "SHARED",
                    value: "SHARED"
                },
                {
                    key: "NONE",
                    value: "NONE"
                }, 
            ]
        },
        {
            description: "",
            from: {
                maxValue: 2020,
                minValue: 1800,
                placeholder: "1800",
                step: 1
            },
            isRange: true,
            label: "year_of_construction",
            name: "byConstructionYear",
            span: "",
            to: {
                maxValue: 2020,
                minValue: 1800,
                placeholder: "2020",
                step: 1
            },
            trendy: false,
            type: "number"
        }, 
    ];
};
var zones = function() {
    return {
        name: "byZone"
    };
};
var onlyCasavo = function() {
    return {
        name: "onlyCasavo"
    };
};
var filtersConfiguration = {
    getServicesValues: getServicesValues,
    onlyCasavo: onlyCasavo,
    others: others,
    priority: priority,
    zones: zones
};
/* harmony default export */ __webpack_exports__["Z"] = (filtersConfiguration);


/***/ }),

/***/ 31750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29559);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62271);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93072);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _zone_slug_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87711);




var geoFilterToSlug = function() {
    var zoneFilter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], zones = arguments.length > 1 ? arguments[1] : void 0;
    return zones.filter(function(zone) {
        return zoneFilter.includes((0,_zone_slug_parser__WEBPACK_IMPORTED_MODULE_1__/* .parseGeoSlug */ .U)(zone));
    });
};
var geoSlugToFilter = function(slug) {
    return slug.includes("/") ? slug.split("/").reverse()[0] : undefined;
};
var formatFiltersForQuery = function(filters, zones) {
    // Remove byZone because we must use byGeoSlug
    var filtersWithoutZone = lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(filters, "byZone");
    return filters.byZone && zones ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, filtersWithoutZone), {
        byGeoSlug: geoFilterToSlug(filters.byZone, zones.map(function(zone) {
            return zone.slug;
        }))
    }) : filtersWithoutZone;
};
var formatRange = function(min, max, t) {
    if (min && max) {
        return "".concat(min, " - ").concat(max);
    } else if (min) {
        return "".concat(t("filter:from"), " ").concat(min);
    } else if (max) {
        return "".concat(t("filter:max"), " ").concat(max);
    }
};
var buildZoneFilter = function(filters) {
    return {
        byZone: filters.filter(Boolean).map(function(filter) {
            return geoSlugToFilter(filter.slug);
        })
    };
};
var buildCityFilter = function(cities) {
    return {
        byZone: cities.filter(Boolean).map(function(city) {
            return geoSlugToFilter(city.slug);
        })
    };
};
var filtersMapperUtils = {
    buildCityFilter: buildCityFilter,
    buildZoneFilter: buildZoneFilter,
    formatFiltersForQuery: formatFiltersForQuery,
    formatRange: formatRange,
    geoFilterToSlug: geoFilterToSlug,
    geoSlugToFilter: geoSlugToFilter
};
/* harmony default export */ __webpack_exports__["Z"] = (filtersMapperUtils);


/***/ }),

/***/ 11755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FV": function() { return /* binding */ getAlternatePageLinksWithZone; },
/* harmony export */   "Gd": function() { return /* binding */ getAlternatePageLinksForListingDetail; },
/* harmony export */   "cF": function() { return /* binding */ getAlternatePageLinksWithCanonicalFilter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89847);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13976);



var getAlternatePageLinksForListingDetail = function(lang, listingId) {
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()().publicRuntimeConfig;
    switch(lang){
        case "fr":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_2__/* .linkBuilder.listingDetail.url */ .H.listingDetail.url(lang, listingId)),
                        hrefLang: "".concat(lang),
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_2__/* .linkBuilder.listingDetail.url */ .H.listingDetail.url(lang, listingId)),
                        hrefLang: "x-default",
                        rel: "alternate"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_2__/* .linkBuilder.listingDetail.url */ .H.listingDetail.url("en", listingId)),
                        hrefLang: "en",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_2__/* .linkBuilder.listingDetail.url */ .H.listingDetail.url("it", listingId)),
                        hrefLang: "it",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite).concat(_components_Link_linkBuilder__WEBPACK_IMPORTED_MODULE_2__/* .linkBuilder.listingDetail.url */ .H.listingDetail.url("it", listingId)),
                        hrefLang: "x-default",
                        rel: "alternate"
                    })
                ]
            });
    }
};
var getAlternatePageLinksWithZone = function(lang, segment) {
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()().publicRuntimeConfig;
    switch(lang){
        case "fr":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/fr/acheter-bien/").concat(segment, "/"),
                        hrefLang: "fr",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/fr/acheter-bien/").concat(segment, "/"),
                        hrefLang: "x-default",
                        rel: "alternate"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/houses-for-sale/").concat(segment, "/"),
                        hrefLang: "en",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/it/case-in-vendita/").concat(segment, "/"),
                        hrefLang: "it",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/it/case-in-vendita/").concat(segment, "/"),
                        hrefLang: "x-default",
                        rel: "alternate"
                    })
                ]
            });
    }
};
var getAlternatePageLinksWithCanonicalFilter = function(lang, citySegment, canonicalFilter) {
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()().publicRuntimeConfig;
    switch(lang){
        case "fr":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/fr/acheter-bien/").concat(citySegment, "/").concat(canonicalFilter.slug.fr, "/"),
                        hrefLang: "fr",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/fr/acheter-bien/").concat(citySegment, "/").concat(canonicalFilter.slug.fr, "/"),
                        hrefLang: "x-default",
                        rel: "alternate"
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/houses-for-sale/").concat(citySegment, "/").concat(canonicalFilter.slug.en, "/"),
                        hrefLang: "en",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/it/case-in-vendita/").concat(citySegment, "/").concat(canonicalFilter.slug.it, "/"),
                        hrefLang: "it",
                        rel: "alternate"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        href: "".concat(publicRuntimeConfig.lisaWebsite, "/it/case-in-vendita/").concat(citySegment, "/").concat(canonicalFilter.slug.it, "/"),
                        hrefLang: "x-default",
                        rel: "alternate"
                    })
                ]
            });
    }
};


/***/ }),

/***/ 55600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76131);
/* harmony import */ var _locale_variables__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98640);


var availableServices = {
    additionalInfo: [
        "coolingSystem"
    ],
    services: [
        "elevator",
        "basement",
        "parkingSpaces",
        "box",
        "garden",
        "conciergeService",
        "recreationRoom",
        "garret",
        "pool",
        "sharedPool",
        "tennisCourt",
        "fireplace",
        "disabledAccess",
        "wallCabinet",
        "fastInternet",
        "hydromassage",
        "tvSystem",
        "electricGate",
        "armoredDoor",
        "alarmSystem",
        "entranceVideoPhone", 
    ]
};
var get = function(listing) {
    var shouldIncludeService = function(service) {
        if ((service === null || service === void 0 ? void 0 : service.counter) && service.counter > 0) {
            return true;
        } else if ((service === null || service === void 0 ? void 0 : service.area) && service.area > 0) {
            return true;
        } else if ((service === null || service === void 0 ? void 0 : service.areas) && service.areas.length > 0) {
            return true;
        } else if (service && service !== "NONE") {
            return true;
        }
        return false;
    };
    var servicesUnderServices = availableServices.services.filter(function(item) {
        return shouldIncludeService(listing.services[item]);
    });
    var servicesUnderAdditionalInfo = availableServices.additionalInfo.filter(function(item) {
        return shouldIncludeService(listing.additionalInfo[item]);
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(servicesUnderServices).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(servicesUnderAdditionalInfo));
};
/**
 * Validate urls containing city not matching its own locale
 * Eg.
 * /it/case-in-vendita/madrid
 * /es/casas-en-venta/milano
 */ var validateCity = function(city, language) {
    // Guard agains spaces inside city name
    var formattedCity = city.replace(/\s+/g, "-");
    return _locale_variables__WEBPACK_IMPORTED_MODULE_0__/* .citiesByLocale */ .F5[language].includes(formattedCity.toLowerCase());
};
// eslint-disable-next-line import/no-anonymous-default-export
/* harmony default export */ __webpack_exports__["Z"] = ({
    get: get,
    validateCity: validateCity
});


/***/ }),

/***/ 10538:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 83795:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);